import React from 'react';
import { CurrenciesObject } from '../../types/Currencies';

type TenantContext = {
  settings: object,
  tenant: string | null,
  updateTenant: Function,
  currencies: CurrenciesObject | null
}

export default React.createContext<TenantContext>({
  settings: {},
  tenant: null,
  updateTenant: (tenant: any) => { console.warn("updateTenant called without a provider", tenant); },
  currencies: {
    sellingCurrency: [],
    buyingCurrency: []
  }
});
